<template>
  <div class="footer">
    <div class="footer-mid">
      <div class="footerBg">
        <img src="../assets/login/footerbg.png">
        <i class="bgColor" style="background-color: #0065BA;"></i>
      </div>
      <div class="mid">
        <div class="footer-content">
          <!-- 左侧：友情链接 -->
          <div class="footer-section links-section">
            <h3 class="section-title">友情链接</h3>
            <div class="links-container d-flex d-flex-between d-flex-wrap">
              <a
                v-for="(item, index) in tenantInfo.friendlyLinksList || []"
                :key="index"
                :href="item.url"
                target="_blank"
                class="link-item"
              >{{ item.name }}</a>
            </div>
          </div>

          <!-- 中间：二维码 -->
          <div class="footer-section brand-section">
            <div class="brand-info">
              <img :src="tenantInfo.logo" :alt="tenantInfo.websiteName" class="university-logo">
            </div>
            <div class="qr-codes">
              <div
                v-for="(item, index) in tenantInfo.wechatAccountsList || []"
                :key="index"
                class="qr-code-item"
              >
                <img :src="item.qrcodeUrl" :alt="item.name" class="qr-code">
                <span class="qr-code-text">{{ item.name }}</span>
              </div>
              <!-- <div class="qr-code-item">
                <img src="../assets/login/ewm_2.png" alt="自考服务公众号" class="qr-code">
              </div> -->
            </div>
          </div>

          <!-- 右侧：联系我们 -->
          <div class="footer-section contact-section">
            <h3 class="section-title">联系我们</h3>
            <div class="contact-info">
              <div
                v-for="(item, index) in tenantInfo.contactAddressList || []"
                :key="index"
                class="contact-item"
              >
                <img src="../assets/footIcon_2.png" alt="" class="contact-icon">
                <span class="contact-text">{{ item.address }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="footer-copyright">
        <div class="copyright">
          <img src="../assets/login/1681190825355.png" width="18px" height="19.5px" alt="">
          <a
            v-for="(item, index) in tenantInfo.icpInfoList || []" :key="index"
            :href="item.url ? item.url : 'javascript:void(0)'"
            target="_blank"
            style="margin-left: 4px;"
          >{{ item.name }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(['tenantInfo'])
  },
  created() {
    this.$store.dispatch('fetchSchoolConfig');
  },
}
</script>
<style lang="scss" scoped>
.footer {
  .footer-mid {
    position: relative;

    .footerBg {
      position: absolute;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      i {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        opacity: 0.9;
      }
    }

    .mid {
      box-sizing: border-box;
      padding: 50px 0 30px 0;
      position: relative;
      z-index: 3;
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .footer-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0 20px;
        gap: 40px;
      }

      .footer-section {
        color: #fff;

        &.links-section {
          flex: 0 0 300px;
        }

        &.brand-section {
          flex: 0 0 400px;
        }

        &.contact-section {
          flex: 0 0 300px;
        }

        .section-title {
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 20px;
          line-height: 1;
        }

        &.links-section {
          .links-container {
            width: 360px;
            .link-item {
                color: #fff;
                font-size: 12px;
                text-decoration: none;
                line-height: 1.8;
                transition: opacity 0.3s;
                width: 50%;
                line-height: 30px;
                &:hover {
                  opacity: 0.8;
                }
              }
          }
        }

        &.brand-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;

          .brand-info {
            margin-bottom: 10px;
            .university-logo{
              height: 50px;
            }
          }

          .qr-codes {
            display: flex;
            gap: 15px;
            justify-content: center;
            margin-top: 15px;

            .qr-code-item {
              .qr-code {
                width: 80px;
                height: 80px;
                background: #fff;
                padding: 0;
                box-sizing: border-box;
                border-radius: 4px;
                display: block;
                object-fit: contain;
              }
              span{
                font-size: 12px;
                color: #fff;
                margin-top: 10px;
              }
            }
          }
        }

        &.contact-section {
          .contact-info {
            display: flex;
            flex-direction: column;
            gap: 15px;

            .contact-item {
              display: flex;
              align-items: flex-start;
              gap: 8px;
              font-size: 14px;
              line-height: 1.6;

              .contact-icon {
                font-size: 16px;
                flex-shrink: 0;
                margin-top: 2px;
                height: 16px;
              }

              .contact-text {
                color: #fff;
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  .footer-copyright {
    font-size: 12px;
    line-height: 30px;
    text-align: center;
    background: #0065BA;
    position: relative;
    z-index: 3;
    box-sizing: border-box;
    padding: 10px 0;

    .copyright {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        color: #fff;
      }

      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>
